// extracted by mini-css-extract-plugin
export var details = "_li-0";
export var inspectorPopover = "_li-1";